import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject, Injector,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALIDATORS} from '@angular/forms';
import {MAT_DATE_FORMATS, MatNativeDateModule, provideNativeDateAdapter} from '@angular/material/core';
import {formatacao_data_br} from '../../formatacaoData';
import {
  MatDatepickerModule,
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker
} from '@angular/material/datepicker';
import {MatIcon, MatIconModule} from '@angular/material/icon';
import {MatCheckbox} from '@angular/material/checkbox';
import {CommonModule, NgClass} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-form-field',
  standalone: true,
  imports: [
    FormsModule,
    MatDateRangeInput,
    MatDatepickerToggle,
    MatDateRangePicker,
    MatIcon,
    MatCheckbox,
    NgClass,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: formatacao_data_br},
    provideNativeDateAdapter(), {
        provide: NG_VALIDATORS, useExisting: forwardRef(()=>FormFieldComponent),
        multi: true
    }
  ],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.css'
})
export class FormFieldComponent implements ControlValueAccessor, OnInit{
  @Input() classe: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = 'Digite';
  @Input() dica?: string;
  @Input() value: any;
  @Input() mask?: string;
  @Input() min: number = 0;
  @Input() max: number = 9999999999999999999;

  @Input() label?: string;
  @Input() colorLabel?: string;

  @Input() iconPrefix?: string;
  @Input() iconSuffix?: string;

  @Input() widthFormField: string = '100%';
  @Input() heightFormField: string = '60px';

  @Input() borderColor?: string;
  @Input() borderWidth?: string;
  @Input() borderRadius?: string;
  @Input() backgroundColor?: string;
  @Input() iconColor?: string;
  @Input() top?: string;
  @Input() left?: string;

  @Input() font?: string;
  @Input() fontLabel?: string;
  @Input() fontWeight?: string;

  @Input() isSenha: boolean = false;
  @Input() iconSuffixSenha: string = 'visibility';

  @Input() isDateRange?: boolean = false;
  @Input() dataInicio?: Date = new Date();
  @Input() dataFim?: Date = new Date();

  @Input() maxLengthFormFiles?: number;
  @Input() disabled: boolean = false;

  @Input() showValidationErrors: boolean = true;
  @Input() customErrorMessages?: { [key: string]: string };

  @Input() isCheckbox: boolean = false;
  @Input() isEdicao: boolean = false;

  @Output() dataFimChange = new EventEmitter();
  @Output() dataInicioChange = new EventEmitter();

  @Output() onChangeValue = new EventEmitter();
  @Output() focusOutValue = new EventEmitter();
  @Output() onEnterKey = new EventEmitter<void>();

  @ViewChild('internalInput') internalInput!: ElementRef<HTMLInputElement>;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  private _control: any;
  private firstChangeComMask: boolean = false;
  private _adapter: any;
  protected isDataRange: any;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private injetctor: Injector
  ) { }
  ngOnInit(): void {
    // _adapter será inicializado quando necessário para date picker
  }
  get control(): any {
    return this._control;
  }
  set control(value: any) {
    this._control = value;
  }
  get adapter(): any {
    return this._adapter;
  }
  set adapter(value: any) {}
  writeValue(obj: any): void {
        throw new Error("Method not implemented.");
    }
    registerOnChange(fn: any): void {
        throw new Error("Method not implemented.");
    }
    registerOnTouched(fn: any): void {
        throw new Error("Method not implemented.");
    }
    setDisabledState?(isDisabled: boolean): void {
        throw new Error("Method not implemented.");
    }
    get isInvalid(): boolean {
      return this._control?.invalid && this._control?.dirty;
    }

   focusOut() {
    this.focusOutValue.emit(this.value);
    this.onTouched();
  }

  handleEnterKey() {
    this.onEnterKey.emit();
  }

  change() {
    if (!this.isDateRange) {
      if (this.firstChangeComMask && this.isEdicao) {
        this.firstChangeComMask = !this.firstChangeComMask;
      } else {
        this.onChangeValue.emit(this.value);
        this.onChange(this.value);
      }
    } else {
      const dateRange = {
        dataInicio: this.dataInicio,
        dataFim: this.dataFim
      };
      this.dataInicioChange.emit(this.dataInicio);
      this.dataFimChange.emit(this.dataFim);
      this.onChange(dateRange);
    }
  }

  toggleMostrarSenha() {
    this.iconSuffixSenha = this.iconSuffixSenha === 'visibility' ? 'visibility_off' : 'visibility';
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  get errors(): any {
    return this._control?.errors;
  }

  getErrorMessage(): string {
    if (!this.errors) return ''
    if (this.customErrorMessages) {
      for (const errorKey of Object.keys(this.errors)) {
        if (this.customErrorMessages[errorKey]) {
          return this.customErrorMessages[errorKey];
        }
      }
    }
    if(this.errors['email']) {
      return 'Email inválido';
    }
    if (this.errors['required']) {
      return `${this.label || 'Este campo'} é obrigatório`;
    }
    return 'Campo inválido';
  }
}
